import { Injectable } from '@angular/core';

const SESSION_SCOPED_KEYS = ['ghp_bookmarks'];
const PRESERVED_KEYS = ['ghp_map', 'ghp_darkMode'];

/**
 * Limpieza global al cerrar sesión.
 * - Elimina del localStorage las claves con datos por sesión/usuario.
 * - Conserva preferencias de usuario (vista de mapa, tema oscuro).
 * - Notifica a los providers registrados para que resetee su estado en memoria.
 */
@Injectable({ providedIn: 'root' })
export class SessionCleanupService {
  private readonly resetCallbacks: Array<() => void> = [];

  registerReset(reset: () => void): () => void {
    this.resetCallbacks.push(reset);
    return () => {
      const idx = this.resetCallbacks.indexOf(reset);
      if (idx >= 0) this.resetCallbacks.splice(idx, 1);
    };
  }

  clear(): void {
    this.clearStorage();
    this.resetCallbacks.forEach((reset) => {
      try {
        reset();
      } catch {
        // un provider no debe romper la limpieza del resto
      }
    });
  }

  private clearStorage(): void {
    for (const key of SESSION_SCOPED_KEYS) {
      localStorage.removeItem(key);
    }

    // Settings ghp_* (LocalStorageSettingRepository) salvo preferencias conservadas.
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith('ghp_') && !PRESERVED_KEYS.includes(key)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  }
}
